import { castEnum } from "../../../../utils/CommonUtils";
export class DocsBlockPropertyDefinition {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c;
        this.id = model.id;
        this.name = model.name;
        this.type = castEnum(model.type);
        this.description = (_a = model.description) !== null && _a !== void 0 ? _a : null;
        this.options = (_b = model.options) !== null && _b !== void 0 ? _b : null;
        this.variantOptions = (_c = model.variantOptions) !== null && _c !== void 0 ? _c : null;
    }
    // --- --- Helpers
    defaultData() {
        return {
            value: undefined,
        };
    }
}
